"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function handleSelectInvalid(e, _a) {
    var actions = _a.actions, config = _a.config, dom = _a.dom;
    actions.invalidate();
}
exports.default = handleSelectInvalid;
//# sourceMappingURL=handleSelectInvalid.js.map